import { Component, Input } from '@angular/core';
import { ITableColumn } from '../../models/table-column';
import { LsqBaseColumnComponent } from './base-column.component';

@Component({
    selector: 'lsq-row-count-column',
    template: `
        <ng-container [cdkColumnDef]="column.key">
            <th
                cdk-header-cell
                *cdkHeaderCellDef
                class="counter"
                [ngStyle]="{ width: width || column.width }"
            ></th>
            <td
                cdk-cell
                *cdkCellDef="let row; let index = index"
                [ngStyle]="{ width: width || column.width }"
                class="counter"
            >
                {{ getRowCount(index) }}
            </td>
            <td cdk-footer-cell *cdkFooterCellDef></td>
        </ng-container>
    `
})
export class LsqRowCountColumnComponent extends LsqBaseColumnComponent {
    @Input() public width = '5rem';

    public column: ITableColumn = {
        key: 'rowCounter'
    };

    public getRowCount(index = 0): number {
        if (this.dataTable.dataSource.skip >= 0) {
            return this.dataTable.dataSource.skip + index + 1;
        } else {
            return index + 1;
        }
    }
}
